module.exports = __webpack_public_path__ + "img/81.1394fa0d.jpg";